import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { containerStyles, messageStyles } from "./LoadingScreen.styles";

interface LoadingScreenProps {
  message?: string;
  size?: number;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ message = "Carregando...", size = 40 }) => {
  return (
    <Box sx={containerStyles}>
      <CircularProgress size={size} thickness={4} />
      <Typography variant="body1" color="text.secondary" sx={messageStyles}>
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingScreen;
